import { getCookie } from '@tencent/halo-utils';

/** 登录类型 */
export const enum LoginType {
  /** QQ 登录 */
  qq = 'qq',
  /** 微信登录 */
  wx = 'wx',
  // 客户端qq互联
  pcqc = 'QC',
  // 客户端微信
  pcwx = 'WX',
  /** 未知登录方式 */
  unknown = 'unknown'
}

/** 用户登录态 */
export interface LoginInfo {
  /**
   * 用户是通过哪种方式登录的
   * @description 从 `LoginType` 枚举中取值, 未登录时为 null
   */
  loginType: LoginType | null;

  /**
   * 登录标识
   * @description 标识当前登录态的 Id, 用于需要取得用户登录信息但不关注如何登录的场景
   */
  loginId: string | null;

  /**
   * QQ 互联登录 OpenId
   * @description 当用户是 QQ 登录且登录方式是互联登录时有效
   */
  qqOpenId?: string;

  /**
   * QQ 互联登录 AccessToken
   * @description 当用户是 QQ 登录且登录方式是互联登录时有效
   */
  qqAccessToken?: string;

  /**
   * 微信 OpenId
   * @description 当用户是微信登录时有效
   */
  wxOpenId?: string;

  /**
   * 微信 UnionId
   * @description 当用户是微信登录且有 UnionId 时有效
   */
  wxUnionId?: string;

  /**
   * 微信 AccessToken
   * @description 当用户是微信登录时有效
   */
  wxAccessToken?: string;

  /**
   * QQ 登录 uin
   * @deprecated
   * @description 当用户是 QQ 登录且登录方式是传统登录时有效
   */
  uin?: string;

  /**
   * QQ 登录 skey
   * @deprecated
   * @description 当用户是 QQ 登录且登录方式是传统登录时有效
   */
  skey?: string;

  /**
   * 用户昵称
   */
  nickname?: string;

  /**
   * 用户头像
   */
  headImg?: string;
}

/** 分享信息 */
export interface ShareInfo {
  [key: string]: any;

  /** 分享标题 */
  title?: string;

  /** 分享描述 */
  desc?: string;

  /** 分享图标链接 */
  icon?: string;

  /** 分享链接 */
  url?: string;

  /** 分享来源 */
  source?: string;
}

/** 坐标信息 */
export interface Coordinates {
  /** 位置精度 */
  readonly accuracy: number | null;

  /** 海拔，海平面以上以米计 */
  readonly altitude: number | null;

  /** 位置的海拔精度 */
  readonly altitudeAccuracy: number | null;

  /** 方向，从正北开始以度计 */
  readonly heading: number | null;

  /** 十进制数的纬度 */
  readonly latitude: number;

  /** 十进制数的经度 */
  readonly longitude: number;

  /** 速度，以米/每秒计 */
  readonly speed: number | null;
}

/** 位置信息 */
export interface Position {
  /** 坐标信息 */
  readonly coords: Coordinates;

  /** 响应的毫秒时间戳 */
  readonly timestamp: number;
}

/** 网络状态信息 */
export const enum NetworkType {
  wifi = 'wifi',
  mobile2g = '2g',
  mobile3g = '3g',
  mobile4g = '4g',
  unknown = 'unknown'
}

/** 设备信息 */
export interface DeviceInfo {
  [key: string]: any;

  /**
   * 欧拉 QIMEI 标识
   * @description 具体使用的 QIMEI 版本会根据媒体端的不同而不同
   */
  qimei?: string;

  /** 国际移动设备识别码 */
  imei?: string;

  /** MAC 地址 */
  mac?: string;

  /** Android Id */
  androidId?: string;
}

export interface DataInterface {
  /** 设置分享信息 */
  setShareInfo(params: ShareInfo): any;

  /** 获取登录态信息 */
  getLoginInfo(): Promise<LoginInfo>;

  /** 获取剪切板内容 */
  getClipboard(): Promise<string>;

  /** 设置剪切板内容 */
  setClipboard(value: string): Promise<void>;

  /** 获取当前网络类型 */
  getNetworkType(): Promise<NetworkType>;

  /**
   * 获取设备位置信息
   *
   * @description
   * 类似浏览器的 [Geolocation API](https://developer.mozilla.org/en-US/docs/Web/API/Geolocation_API),
   * 在支持的媒体端上通过媒体端能力获取设备当前位置, 不需要浏览器额外授权
   */
  getCurrentPosition(): Promise<Position>;

  /** 获取设备信息 */
  getDeviceInfo(): Promise<DeviceInfo>;
}

export namespace settings{
  /**
   * 键的状态
   * 同时按下，or运算给出
   */
  export enum SettingKeyState{
    alt = 0x0001,
    ctrl = 0x0002,
    shift = 0x0004,
    win = 0x0008,
  }
  export enum SettingKeyValue{
    ';:' = 0xBA,
    '+' = 0xBB,
    ',' = 0xBC,
    '-' =0xBD,
    '.' =0xBE,
    '/?' =0xBF,
    '`~' =0xC0
  }
  export enum SettingRenderMode{
    'OpenGL'=0,
    'DirectX'=1,
    'auto'=3
  }
  export enum SettingFaxxQuality{
    'normal'=0,
    'high'=1,
    '2k'=2
  }
  export enum SettingGameDpi{
    'closed'=0,
    'balance'=1,
    'perfection'=2
  }
  export enum SettingGameQuality{
    auto=-1,
    'fluent'=0,
    'balance'=1,
    'high'=2
  }
  export enum SettingGameFps{
    'auto'=0,
    fps30=4,
    fps40=5,
    fps60=6,
    fps90=7,
    fps120=8
  }
  export interface InitSettingTabsBasic {
    autoBoot: 0 | 1;
    wtrMark: 0 | 1;
    dpiAware: 0|1;
    bossKey: [SettingKeyState, SettingKeyValue];
    curLang: string;
    region: string; // 前端传啥客户端记录啥 [ok]
    snapShoot: string; // 浏览接口 & 路径回调通知 & 打开接口
  }

  export interface InitSettingTabsEngine {
    renderMode: SettingRenderMode;
    faxxQuality: SettingFaxxQuality;
    memorySize: number; // 0 1024.... ,
    CPUCount: number; // 0, 1 , 2 ....,
    Resolute: [number, number]; // 游戏蜂窝是啥 TODO：获得所有分辨率的接口, [游戏蜂窝删除，分辨率接口前端写死，配置过高，客户端设置成顶配]
    shaderCache: 0 | 1; // 渲染缓存,
    graphicsCard: 0 | 1; // 独立显卡,
    renderOptimize: 0 | 1; // 渲染优化,
    vsyncEnable: 0 | 1; // 垂直同步,
    localCache: 0 | 1; // TODO 强制全局渲染缓存,[ok]
    vmDPI: 0 | 1| 2;   // 0:normal,1:high,2:2k
    devices: {
      player: {
      /**
       *  [deviceid,deviceName][]
       */
        list: [string, string][];
        current: string;
      };
      record: {
      /**
       *  [deviceid,deviceName][]
       */
        list: [string, string][];
        current: string;
      };
    };
  }
  export interface InitSettingTabsPhone {
    model: string;
    company: string;
  }
  export interface InitSettingTabsGame {
    [gameName: string]: {
      name: string;
      dpi: SettingGameDpi;
      quality: SettingGameQuality;
      fps: SettingGameFps;
    };
  }
}

/**
 * 获取用户信息
 * @returns
 */
export async function getLoginInfo(): Promise<LoginInfo> {
  const openid = getCookie('openid') || '';
  const accesstoken = getCookie('accesstoken') || '';
  const loginType: LoginType = getCookie('logintype') as LoginType;

  return {
    loginId: openid,
    qqOpenId: loginType === LoginType.pcqc ? openid : '',
    qqAccessToken: loginType === LoginType.pcqc ? accesstoken : '',
    wxOpenId: loginType === LoginType.pcwx ? openid : '',
    wxAccessToken: loginType === LoginType.pcwx ? accesstoken : '',
    loginType,
    nickname: getCookie('nickname'),
    headImg: getCookie('headImg'),
  };
}

/**
 * 获取设备信息
 * @returns
 */
export async function getDeviceInfo(): Promise<DeviceInfo> {
  return {
    region: localStorage.getItem('syzs_region') || '',
    guid: localStorage.getItem('syzs_guid') || '',
    lang: localStorage.getItem('syzs_lang') || '',
  };
}
